import {CommonClinicalSupportXlsxDataProcessor} from '../export-care-plan-common-clinical-xlsx-data';

export class OtherXlsxDataProcessor extends CommonClinicalSupportXlsxDataProcessor {
  // Inherits the same headers and row structure as Common processor.
}
